import styled from '@emotion/styled'
import * as constants from 'view/styles/constants'
import { LoaderAnimation } from 'view/components/loader/Loader'

export const Bar = styled.div`
  padding: 3px 6px;
  margin-bottom: 3px;
  color: ${constants.CORE_PRIMARY};
  background-color: ${constants.ACCENT_GOOD};
  border-radius: ${constants.panelBorderRadius};
  outline: none;
  display: flex;
  align-items: center;
  svg {
    height: 16px;
    width: 16px;
    margin: 0 6px;
  }
`

export const SuccessBar = styled(Bar)`
  background-color: ${constants.ACCENT_GOOD};
`

export const ErrorBar = styled(Bar)`
  background-color: ${constants.ACCENT_BAD};
`

export const ErrorNarrative = styled.div`
  padding: 3px 6px;
  font-weight: ${constants.FontWeight.SemiBold};
  font-size: 12px;
  width: 400px;
`

export const ParseResultLoading = styled(LoaderAnimation)`
  height: 32px;
  transform: scale(0.5);
  transform-origin: top left;
  left: calc(50% - 32px);
`
